// // import React, { useState, useEffect, useRef } from "react";
// // import axios from 'axios';
// // import { FaEdit, FaTrash, FaSave } from 'react-icons/fa';
// // import { FaTimes } from 'react-icons/fa';


// // const Timings = () => {

// //   const isMobile = window.innerWidth <= 768;
// //   const [vendorId, setVendorId] = useState(null);
// //   const [timings, setTimings] = useState([]);
// //   const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
// //   const [showAddPopup, setShowAddPopup] = useState(false);

// //   const scrollContainerRef = useRef(null);
// //   useEffect(() => {
// //     const storedVendorId = localStorage.getItem("vendorId");
// //     if (storedVendorId) {
// //       setVendorId(storedVendorId);
// //     }
// //   }, []);

// //   const getTableHeight = () => {
// //     const width = window.innerWidth;

// //     if (width <= 600) return "400px";               // Mobile
// //     if (width >= 1000 && width <= 1300) return "400px"; // 1000–1300px
// //     if (width > 1300) return "500px";               // Large screens

// //     return "auto";  // default
// //   };

// //   useEffect(() => {
// //     const storedVendorId = localStorage.getItem("vendorId");
// //     const token = localStorage.getItem("authToken"); // ✅ Get token

// //     if (!storedVendorId || !token) {
// //       alert("Missing vendor ID or authentication token. Please log in again.");
// //       return;
// //     }

// //     setVendorId(storedVendorId);

// //     const fetchTimings = () => {
// //       axios
// //         .get(
// //           `https://backend.maamaas.com/food/api/timings/get/timings/${storedVendorId}`,
// //           {
// //             headers: {
// //               Authorization: `Bearer ${token}`, // ✅ Include token in header
// //             },
// //           }
// //         )
// //         .then((response) => {
// //           const apiTimings = Array.isArray(response.data) ? response.data : [response.data];

// //           const mappedTimings = apiTimings.map((item) => ({
// //             id: item.id,
// //             day: item.day,
// //             open: item.startTime ? item.startTime.substring(0, 5) : '',
// //             close: item.lastTime ? item.lastTime.substring(0, 5) : '',
// //             checked: item.restaurantStatus === 'Open',
// //             restaurantStatus: item.restaurantStatus,
// //             isEditing: false,
// //           }));

// //           setTimings(mappedTimings);
// //         })
// //         .catch((err) => {
// //           console.error('Failed to fetch timings', err);
// //           setTimings([]);
// //         });
// //     };

// //     fetchTimings(); // Initial fetch

// //     const intervalId = setInterval(fetchTimings, 10000); // Refresh every 10 seconds

// //     return () => clearInterval(intervalId); // Cleanup on unmount
// //   }, []);




// //   const handleAddTiming = () => {
// //     const vendorId = localStorage.getItem("vendorId"); // ✅ Ensure vendorId is fetched
// //     const token = localStorage.getItem("authToken"); // ✅ Fetch token from localStorage

// //     if (!vendorId) {
// //       alert("Vendor ID missing. Please refresh or login again.");
// //       return;
// //     }

// //     if (!token) {
// //       alert("Authentication token missing. Please log in again.");
// //       return;
// //     }

// //     if (!newTiming.day || !newTiming.open || !newTiming.close) {
// //       alert("Please fill all fields.");
// //       return;
// //     }

// //     const payload = {
// //       day: newTiming.day,
// //       startTime: newTiming.open + ":00", // e.g., "09:00:00"
// //       lastTime: newTiming.close + ":00",
// //     };

// //     console.log("Sending payload:", payload);

// //     axios
// //       .post(
// //         `https://backend.maamaas.com/food/api/timings/daytimings/${vendorId}`,
// //         payload,
// //         {
// //           headers: {
// //             "Content-Type": "application/json",
// //             Authorization: `Bearer ${token}`, // ✅ Include token in header
// //           },
// //         }
// //       )
// //       .then((res) => {
// //         console.log("Success:", res.data);
// //         alert("Timing added successfully!");
// //         window.location.reload();
// //         setShowAddPopup(false);
// //         setNewTiming({ day: "", open: "", close: "" });
// //       })
// //       .catch((err) => {
// //         console.error("Failed to add timing:", err);
// //         if (err.response) {
// //           console.error("Status:", err.response.status);
// //           console.error("Data:", JSON.stringify(err.response.data, null, 2));
// //           alert("Error adding timing: " + JSON.stringify(err.response.data));
// //         } else {
// //           alert("Network error or server not reachable.");
// //         }
// //       });
// //   };



// //   const handleDeleteTiming = (id) => {
// //     const token = localStorage.getItem("authToken"); // 🔐 Get token from localStorage

// //     if (!token) {
// //       alert("Authentication token missing. Please log in again.");
// //       return;
// //     }

// //     if (!window.confirm('Are you sure you want to delete this timing?')) return;

// //     console.log('Deleting timing with id:', id); // For debugging

// //     axios
// //       .delete(
// //         `https://backend.maamaas.com/food/api/timings/delete/day/timings/${id}`,
// //         {
// //           headers: {
// //             Authorization: `Bearer ${token}`, // ✅ Include token in header
// //           },
// //         }
// //       )
// //       .then((res) => {
// //         console.log('Deleted timing:', res.data);
// //         setTimings((prev) => prev.filter((timing) => timing.id !== id));
// //       })
// //       .catch((err) => {
// //         console.error('Failed to delete timing:', err.response?.data || err.message);
// //         alert('Failed to delete timing. Please try again.');
// //       });
// //   };


// //   const toggleEdit = (index) => {
// //     const timing = timings[index];
// //     const token = localStorage.getItem("authToken"); // 🔐 Get token

// //     if (!token) {
// //       alert("Authentication token missing. Please log in again.");
// //       return;
// //     }

// //     if (timing.isEditing) {
// //       // Construct the payload
// //       const updatedData = {
// //         id: timing.id,
// //         day: timing.day,
// //         startTime: timing.open,
// //         lastTime: timing.close,
// //         // restaurantStatus: timing.checked ? "Open" : "Closed",
// //       };

// //       console.log("➡️ Sending PUT to edit timing:");
// //       console.table(updatedData);

// //       axios
// //         .put(
// //           `https://backend.maamaas.com/food/api/timings/edit/timings/${timing.id}`,
// //           updatedData,
// //           {
// //             headers: {
// //               "Content-Type": "application/json",
// //               Authorization: `Bearer ${token}`, // ✅ Include token here
// //             },
// //           }
// //         )
// //         .then((res) => {
// //           const updatedTiming = res.data;

// //           setTimings((prev) => {
// //             const updated = [...prev];
// //             updated[index] = {
// //               ...updated[index],
// //               day: updatedTiming.day,
// //               open: updatedTiming.startTime?.substring(0, 5),
// //               close: updatedTiming.lastTime?.substring(0, 5),
// //               checked: updatedTiming.restaurantStatus === "Open",
// //               isEditing: false,
// //             };
// //             return updated;
// //           });

// //           alert("✅ Timing updated successfully!");
// //         })
// //         .catch((err) => {
// //           console.error("❌ Failed to update timing", err);
// //           console.error("🧾 Response:", err.response?.data);
// //           alert("Failed to save timing. Please try again.");
// //         });
// //     } else {
// //       // Enable edit mode
// //       setTimings((prev) => {
// //         const updated = [...prev];
// //         updated[index].isEditing = true;
// //         return updated;
// //       });
// //     }
// //   };

// //   const handleSubmit = e => {
// //     e.preventDefault();
// //     const savedData = timings.map(({ day, open, close }) => ({ day, open, close }));
// //     console.log('Saved Timings:', savedData);
// //     // alert('Timings submitted! Check console for data.');
// //   };

// //   const handleCheckboxChange = (index) => {
// //     const updated = [...timings];
// //     updated[index].checked = !updated[index].checked;
// //     setTimings(updated);
// //   };


// //   // const [timings, setTimings] = useState(
// //   //   defaultTimings.map(t => ({ ...t, isEditing: false }))
// //   // );

// //   const handleChange = (index, field, value) => {
// //     const updatedTimings = [...timings];
// //     updatedTimings[index][field] = value;
// //     setTimings(updatedTimings);
// //   };

// //   const [showAddModal, setShowAddModal] = useState(false);
// //   const [newTiming, setNewTiming] = useState({
// //     day: 'Monday',
// //     open: '',
// //     close: '',
// //     // checked: false,
// //     // restaurantStatus: 'Open',
// //     // isEditing: false,
// //   });

// //   // This is the missing function, needed for modal inputs
// //   const handleNewTimingChange = (field, value) => {
// //     setNewTiming(prev => ({ ...prev, [field]: value }));
// //   };

// //   const addNewTiming = () => {
// //     // Optionally validate fields here

// //     // Check if day already exists in timings, prevent duplicates
// //     if (timings.some(t => t.day === newTiming.day)) {
// //       alert('Timing for this day already exists');
// //       return;
// //     }

// //     setTimings(prev => [...prev, newTiming]);
// //     setShowAddModal(false);

// //     // Reset newTiming to defaults if needed
// //     setNewTiming({
// //       day: 'Monday',
// //       open: '',
// //       close: '',
// //       // checked: false,
// //       // restaurantStatus: 'Open',
// //       // isEditing: false,
// //     });
// //   };




// //   return (
// //     <div style={{ padding: "0px", marginTop: "10px" }}>
// //       <form onSubmit={handleSubmit}>
// //         {/* <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Outlet Timings</h2> */}

// //         <button
// //           onClick={() => setShowAddModal(true)}
// //           style={{
// //             marginBottom: '15px',
// //             padding: '8px 15px',
// //             fontSize: '16px',
// //             cursor: 'pointer',
// //             backgroundColor: 'rgb(177 92 214)',
// //             color: 'white',
// //             border: 'none',
// //             borderRadius: '4px',
// //             fontWeight: 'bold',
// //           }}
// //         >
// //           Add +
// //         </button>

// //         {showAddModal && (
// //           <div
// //             style={{
// //               position: 'fixed',
// //               top: 0, left: 0, right: 0, bottom: 0,
// //               backgroundColor: 'rgba(0,0,0,0.5)',
// //               display: 'flex',
// //               alignItems: 'center',
// //               justifyContent: 'center',
// //               zIndex: 1000,
// //             }}
// //           >
// //             <div
// //               style={{
// //                 backgroundColor: 'white',
// //                 padding: '24px',
// //                 borderRadius: '10px',
// //                 width: '360px',
// //                 boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
// //                 position: 'relative',
// //                 fontFamily: 'Arial, sans-serif',
// //               }}
// //             >
// //               {/* Close Icon */}
// //               <button
// //                 onClick={() => setShowAddModal(false)}
// //                 style={{
// //                   position: 'absolute',
// //                   top: '10px',
// //                   right: '10px',
// //                   // backgroundColor: '#4A148C', // Block color
// //                   color: '#000',
// //                   border: 'none',
// //                   borderRadius: '50%',
// //                   width: '30px',
// //                   height: '30px',
// //                   fontSize: '16px',
// //                   cursor: 'pointer',
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   // boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
// //                 }}
// //                 aria-label="Close modal"
// //               >
// //                 <FaTimes />
// //               </button>


// //               <h3 style={{ marginBottom: '20px', color: '#4A148C', textAlign: 'center' }}>Add Timing</h3>

// //               <div style={{ marginBottom: '15px' }}>
// //                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Day:</label>
// //                 <select
// //                   value={newTiming.day}
// //                   onChange={e => handleNewTimingChange('day', e.target.value)}
// //                   style={{
// //                     width: '100%',
// //                     padding: '8px',
// //                     border: '1px solid #ccc',
// //                     borderRadius: '5px',
// //                     fontSize: '14px',
// //                   }}
// //                 >
// //                   {allDays.map(day => (
// //                     <option key={day} value={day}>{day}</option>
// //                   ))}
// //                 </select>
// //               </div>

// //               <div style={{ marginBottom: '15px' }}>
// //                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Open Time:</label>
// //                 <input
// //                   type="time"
// //                   value={newTiming.open}
// //                   onChange={e => handleNewTimingChange('open', e.target.value)}
// //                   style={{
// //                     width: '100%',
// //                     padding: '8px',
// //                     border: '1px solid #ccc',
// //                     borderRadius: '5px',
// //                     fontSize: '14px',
// //                   }}
// //                 />
// //               </div>

// //               <div style={{ marginBottom: '20px' }}>
// //                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Close Time:</label>
// //                 <input
// //                   type="time"
// //                   value={newTiming.close}
// //                   onChange={e => handleNewTimingChange('close', e.target.value)}
// //                   style={{
// //                     width: '100%',
// //                     padding: '8px',
// //                     border: '1px solid #ccc',
// //                     borderRadius: '5px',
// //                     fontSize: '14px',
// //                   }}
// //                 />
// //               </div>

// //               <div style={{ textAlign: 'center' }}>
// //                 <button
// //                   onClick={handleAddTiming}
// //                   style={{
// //                     padding: '10px 20px',
// //                     cursor: 'pointer',
// //                     backgroundColor: 'rgb(177, 92, 214)',
// //                     color: 'white',
// //                     border: 'none',
// //                     borderRadius: '5px',
// //                     fontSize: '15px',
// //                   }}
// //                 >
// //                   Save
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}

// //         <div style={{ height: getTableHeight(), overflowY: "auto" }}>
// //           <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "0px" }}>
// //             <thead>
// //               <tr>
// //                 <th style={tableHeaderStyle}>S No</th>
// //                 <th style={tableHeaderStyle}>Day</th>
// //                 <th style={tableHeaderStyle}>Open Time</th>
// //                 <th style={tableHeaderStyle}>Close Time</th>
// //                 <th style={tableHeaderStyle}>Action</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {timings.map((item, index) => (
// //                 <tr
// //                   key={item.day}
// //                 // style={index % 2 === 0 ? evenRowStyle : oddRowStyle}

// //                 >
// //                   <td style={tableCellStyle}>
// //                     {index + 1}
// //                   </td>

// //                   <td style={tableCellStyle}>
// //                     {item.isEditing ? (
// //                       <input
// //                         type="text"
// //                         value={item.day}
// //                         onChange={e => handleChange(index, 'day', e.target.value)}
// //                         style={inputStyle}
// //                       />
// //                     ) : (
// //                       item.day
// //                     )}
// //                   </td>

// //                   <td style={tableCellStyle}>
// //                     {item.isEditing ? (
// //                       <input
// //                         type="time"
// //                         value={item.open}
// //                         onChange={e => handleChange(index, 'open', e.target.value)}
// //                         style={inputStyle}
// //                       />
// //                     ) : (
// //                       item.open || '-'
// //                     )}
// //                   </td>
// //                   <td style={tableCellStyle}>
// //                     {item.isEditing ? (
// //                       <input
// //                         type="time"
// //                         value={item.close}
// //                         onChange={e => handleChange(index, 'close', e.target.value)}
// //                         style={inputStyle}
// //                       />
// //                     ) : (
// //                       item.close || '-'
// //                     )}
// //                   </td>
// //                   <td style={tableCellStyle}>
// //                     <button
// //                       type="button"
// //                       onClick={() => toggleEdit(index)}
// //                       style={{
// //                         ...buttonStyle,
// //                         background: 'none',
// //                         border: 'none',
// //                         cursor: 'pointer',
// //                         fontSize: '18px',
// //                         color: '#4A148C',
// //                         marginRight: '8px',
// //                       }}
// //                     >
// //                       {item.isEditing ? <FaSave /> : <FaEdit />}
// //                     </button>

// //                     <button
// //                       type="button"
// //                       onClick={() => handleDeleteTiming(item.id)}
// //                       style={{
// //                         ...buttonStyle,
// //                         background: 'none',
// //                         border: 'none',
// //                         cursor: 'pointer',
// //                         fontSize: '18px',
// //                         color: 'red',
// //                       }}
// //                       title="Delete Timing"
// //                     >
// //                       <FaTrash />
// //                     </button>
// //                   </td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //         </div>
// //         <div style={{ textAlign: 'center', marginTop: '20px' }}>
// //           {/* <button
// //             type="submit"
// //             style={{ ...buttonStyle, backgroundColor: '#28a745' }}
// //           >
// //             Submit All
// //           </button> */}
// //         </div>
// //       </form>

// //     </div>
// //   );
// // };

// // const tableHeaderStyle = {

// //   border: '1px solid #ddd',
// //   textAlign: 'center',
// //   fontWeight: 'bold',
// //   backgroundColor: '#b15cd6',
// //   color: 'white',
// // };

// // const tableCellStyle = {

// //   border: '1px solid #ddd',
// //   textAlign: 'center',
// // };

// // const tableCellStyle1 = {
// //   border: '1px solid #ddd',
// //   fontWeight: 'bold',
// //   fontSize: "16px",
// // };

// // const evenRowStyle = {
// //   backgroundColor: '#f9f9f9',
// // };

// // const oddRowStyle = {
// //   backgroundColor: '#fff',
// // };
// // const inputStyle = {
// //   width: '100%',
// //   border: 'none',
// //   backgroundColor: 'transparent',
// //   textAlign: 'center',
// // };
// // const buttonStyle = {

// //   backgroundColor: '#dc3545',
// //   color: 'white',
// //   border: 'none',
// //   borderRadius: '4px',
// //   cursor: 'pointer',
// //   marginRight: "5px"
// // };
// // const buttonStyle1 = {

// //   backgroundColor: 'green',
// //   color: 'white',
// //   border: 'none',
// //   borderRadius: '4px',
// //   cursor: 'pointer',
// //   marginRight: "5px"
// // };
// // const addButtonStyle = {
// //   marginBottom: '10px',

// //   backgroundColor: '#b15cd6',
// //   color: 'white',
// //   border: 'none',
// //   cursor: 'pointer',
// //   borderRadius: "5px",
// //   width: "100px"
// // };



// // const deleteButtonStyle = {
// //   backgroundColor: 'red',
// //   color: 'white',
// //   border: 'none',
// //   padding: '5px 10px',
// //   cursor: 'pointer',
// //   borderRadius: '5px'
// // };
// // const iconButtonStyle = {
// //   backgroundColor: 'transparent',
// //   border: 'none',
// //   cursor: 'pointer',
// //   fontSize: '18px',
// //   marginRight: '8px',
// //   color: '#333',
// // };


// // const modalOverlayStyle = {
// //   position: 'fixed',
// //   top: 0,
// //   left: 0,
// //   right: 0,
// //   bottom: -50,
// //   backgroundColor: 'rgba(0,0,0,0.2)',
// //   display: 'flex',
// //   justifyContent: 'center',
// //   alignItems: 'center',
// //   zIndex: 1000,
// // };

// // const modalContentStyle = {
// //   backgroundColor: '#fff',
// //   padding: '20px',
// //   borderRadius: '10px',
// //   minWidth: '300px',
// //   boxShadow: '0px 0px 10px rgba(0,0,0,0.2)',
// // };




// // export default Timings;





// import React, { useState, useEffect, useRef } from "react";
// import axios from 'axios';
// import { FaEdit, FaTrash, FaSave } from 'react-icons/fa';
// import { FaTimes } from 'react-icons/fa';

// const Timings = () => {
//   const isMobile = window.innerWidth <= 768;
//   const [vendorId, setVendorId] = useState(null);
//   const [timings, setTimings] = useState([]);
//   const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
//   const [showAddPopup, setShowAddPopup] = useState(false);

//   const scrollContainerRef = useRef(null);
  
//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     if (storedVendorId) {
//       setVendorId(storedVendorId);
//     }
//   }, []);

//   const getTableHeight = () => {
//     const width = window.innerWidth;

//     if (width <= 600) return "400px";
//     if (width >= 1000 && width <= 1300) return "400px";
//     if (width > 1300) return "500px";

//     return "auto";
//   };

//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     const token = localStorage.getItem("authToken");

//     if (!storedVendorId || !token) {
//       alert("Missing vendor ID or authentication token. Please log in again.");
//       return;
//     }

//     setVendorId(storedVendorId);

//     const fetchTimings = () => {
//       axios
//         .get(
//           `https://backend.maamaas.com/food/api/timings/get/timings/${storedVendorId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         )
//         .then((response) => {
//           const apiTimings = Array.isArray(response.data) ? response.data : [response.data];

//           const mappedTimings = apiTimings.map((item) => ({
//             id: item.id,
//             day: item.day,
//             open: item.startTime ? item.startTime.substring(0, 5) : '',
//             close: item.lastTime ? item.lastTime.substring(0, 5) : '',
//             checked: item.restaurantStatus === 'Open',
//             restaurantStatus: item.restaurantStatus,
//             isEditing: false,
//           }));

//           setTimings(mappedTimings);
//         })
//         .catch((err) => {
//           console.error('Failed to fetch timings', err);
//           setTimings([]);
//         });
//     };

//     fetchTimings();
//     const intervalId = setInterval(fetchTimings, 10000);

//     return () => clearInterval(intervalId);
//   }, []);

//   const handleAddTiming = () => {
//     const vendorId = localStorage.getItem("vendorId");
//     const token = localStorage.getItem("authToken");

//     if (!vendorId) {
//       alert("Vendor ID missing. Please refresh or login again.");
//       return;
//     }

//     if (!token) {
//       alert("Authentication token missing. Please log in again.");
//       return;
//     }

//     if (!newTiming.day || !newTiming.open || !newTiming.close) {
//       alert("Please fill all fields.");
//       return;
//     }

//     // Check if maximum 7 days reached
//     if (timings.length >= 7) {
//       alert("Maximum limit reached! You can only add 7 days (one for each day of the week).");
//       return;
//     }

//     // Check if day already exists
//     if (timings.some(timing => timing.day === newTiming.day)) {
//       alert(`Timing for ${newTiming.day} already exists!`);
//       return;
//     }

//     const payload = {
//       day: newTiming.day,
//       startTime: newTiming.open + ":00",
//       lastTime: newTiming.close + ":00",
//     };

//     console.log("Sending payload:", payload);

//     axios
//       .post(
//         `https://backend.maamaas.com/food/api/timings/daytimings/${vendorId}`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//       .then((res) => {
//         console.log("Success:", res.data);
//         alert("Timing added successfully!");
//         window.location.reload();
//         setShowAddModal(false);
//         setNewTiming({ day: "Monday", open: "", close: "" });
//       })
//       .catch((err) => {
//         console.error("Failed to add timing:", err);
//         if (err.response) {
//           console.error("Status:", err.response.status);
//           console.error("Data:", JSON.stringify(err.response.data, null, 2));
//           alert("Error adding timing: " + JSON.stringify(err.response.data));
//         } else {
//           alert("Network error or server not reachable.");
//         }
//       });
//   };

//   const handleDeleteTiming = (id) => {
//     const token = localStorage.getItem("authToken");

//     if (!token) {
//       alert("Authentication token missing. Please log in again.");
//       return;
//     }

//     if (!window.confirm('Are you sure you want to delete this timing?')) return;

//     console.log('Deleting timing with id:', id);

//     axios
//       .delete(
//         `https://backend.maamaas.com/food/api/timings/delete/day/timings/${id}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//       .then((res) => {
//         console.log('Deleted timing:', res.data);
//         setTimings((prev) => prev.filter((timing) => timing.id !== id));
//       })
//       .catch((err) => {
//         console.error('Failed to delete timing:', err.response?.data || err.message);
//         alert('Failed to delete timing. Please try again.');
//       });
//   };

//   const toggleEdit = (index) => {
//     const timing = timings[index];
//     const token = localStorage.getItem("authToken");

//     if (!token) {
//       alert("Authentication token missing. Please log in again.");
//       return;
//     }

//     if (timing.isEditing) {
//       const updatedData = {
//         id: timing.id,
//         day: timing.day,
//         startTime: timing.open,
//         lastTime: timing.close,
//       };

//       console.log("➡️ Sending PUT to edit timing:");
//       console.table(updatedData);

//       axios
//         .put(
//           `https://backend.maamaas.com/food/api/timings/edit/timings/${timing.id}`,
//           updatedData,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         )
//         .then((res) => {
//           const updatedTiming = res.data;

//           setTimings((prev) => {
//             const updated = [...prev];
//             updated[index] = {
//               ...updated[index],
//               day: updatedTiming.day,
//               open: updatedTiming.startTime?.substring(0, 5),
//               close: updatedTiming.lastTime?.substring(0, 5),
//               checked: updatedTiming.restaurantStatus === "Open",
//               isEditing: false,
//             };
//             return updated;
//           });

//           alert("✅ Timing updated successfully!");
//         })
//         .catch((err) => {
//           console.error("❌ Failed to update timing", err);
//           console.error("🧾 Response:", err.response?.data);
//           alert("Failed to save timing. Please try again.");
//         });
//     } else {
//       setTimings((prev) => {
//         const updated = [...prev];
//         updated[index].isEditing = true;
//         return updated;
//       });
//     }
//   };

//   const handleSubmit = e => {
//     e.preventDefault();
//     const savedData = timings.map(({ day, open, close }) => ({ day, open, close }));
//     console.log('Saved Timings:', savedData);
//   };

//   const handleCheckboxChange = (index) => {
//     const updated = [...timings];
//     updated[index].checked = !updated[index].checked;
//     setTimings(updated);
//   };

//   const handleChange = (index, field, value) => {
//     const updatedTimings = [...timings];
//     updatedTimings[index][field] = value;
//     setTimings(updatedTimings);
//   };

//   const [showAddModal, setShowAddModal] = useState(false);
//   const [newTiming, setNewTiming] = useState({
//     day: 'Monday',
//     open: '',
//     close: '',
//   });

//   const handleNewTimingChange = (field, value) => {
//     setNewTiming(prev => ({ ...prev, [field]: value }));
//   };

//   // Get available days (days that haven't been added yet)
//   const getAvailableDays = () => {
//     const existingDays = timings.map(timing => timing.day);
//     return allDays.filter(day => !existingDays.includes(day));
//   };

//   // Disable add button if all 7 days are added
//   const isAddButtonDisabled = timings.length >= 7;

//   return (
//     <div style={{ padding: "0px", marginTop: "10px" }}>
//       <form onSubmit={handleSubmit}>
//         <button
//           onClick={() => setShowAddModal(true)}
//           style={{
//             marginBottom: '15px',
//             padding: '8px 15px',
//             fontSize: window.innerWidth<=1300 ? '13px' : '16px',
//             cursor: isAddButtonDisabled ? 'not-allowed' : 'pointer',
//             backgroundColor: isAddButtonDisabled ? '#cccccc' : 'rgb(177 92 214)',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontWeight: 'bold',
//             opacity: isAddButtonDisabled ? 0.6 : 1,
//           }}
//           disabled={isAddButtonDisabled}
//           title={isAddButtonDisabled ? "All 7 days already added" : "Add new timing"}
//         >
//           Add + {timings.length}/7
//         </button>

//         {showAddModal && (
//           <div
//             style={{
//               position: 'fixed',
//               top: 0, left: 0, right: 0, bottom: 0,
//               backgroundColor: 'rgba(0,0,0,0.5)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               zIndex: 1000,
//             }}
//           >
//             <div
//               style={{
//                 backgroundColor: 'white',
//                 padding: '24px',
//                 borderRadius: '10px',
//                 width: '360px',
//                 boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
//                 position: 'relative',
//                 fontFamily: 'Arial, sans-serif',
//               }}
//             >
//               <button
//                 onClick={() => setShowAddModal(false)}
//                 style={{
//                   position: 'absolute',
//                   top: '10px',
//                   right: '10px',
//                   color: '#000',
//                   border: 'none',
//                   borderRadius: '50%',
//                   width: '30px',
//                   height: '30px',
//                   fontSize: '16px',
//                   cursor: 'pointer',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                 }}
//                 aria-label="Close modal"
//               >
//                 <FaTimes />
//               </button>

//               <h3 style={{ marginBottom: '20px', color: '#4A148C', textAlign: 'center' }}>Add Timing</h3>
              
//               <div style={{ marginBottom: '10px', textAlign: 'center', color: '#666', fontSize: '14px' }}>
//                 {timings.length} of 7 days added
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Day:</label>
//                 <select
//                   value={newTiming.day}
//                   onChange={e => handleNewTimingChange('day', e.target.value)}
//                   style={{
//                     width: '100%',
//                     padding: '8px',
//                     border: '1px solid #ccc',
//                     borderRadius: '5px',
//                     fontSize: '14px',
//                   }}
//                 >
//                   {getAvailableDays().map(day => (
//                     <option key={day} value={day}>{day}</option>
//                   ))}
//                 </select>
//                 {getAvailableDays().length === 0 && (
//                   <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
//                     All days have been added!
//                   </div>
//                 )}
//               </div>

//               <div style={{ marginBottom: '15px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Open Time:</label>
//                 <input
//                   type="time"
//                   value={newTiming.open}
//                   onChange={e => handleNewTimingChange('open', e.target.value)}
//                   style={{
//                     width: '100%',
//                     padding: '8px',
//                     border: '1px solid #ccc',
//                     borderRadius: '5px',
//                     fontSize: '14px',
//                   }}
//                   required
//                 />
//               </div>

//               <div style={{ marginBottom: '20px' }}>
//                 <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Close Time:</label>
//                 <input
//                   type="time"
//                   value={newTiming.close}
//                   onChange={e => handleNewTimingChange('close', e.target.value)}
//                   style={{
//                     width: '100%',
//                     padding: '8px',
//                     border: '1px solid #ccc',
//                     borderRadius: '5px',
//                     fontSize: '14px',
//                   }}
//                   required
//                 />
//               </div>

//               <div style={{ textAlign: 'center' }}>
//                 <button
//                   onClick={handleAddTiming}
//                   disabled={getAvailableDays().length === 0}
//                   style={{
//                     padding: '10px 20px',
//                     cursor: getAvailableDays().length === 0 ? 'not-allowed' : 'pointer',
//                     backgroundColor: getAvailableDays().length === 0 ? '#cccccc' : 'rgb(177, 92, 214)',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '5px',
//                     fontSize: '15px',
//                     opacity: getAvailableDays().length === 0 ? 0.6 : 1,
//                   }}
//                 >
//                   Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         <div style={{ height: getTableHeight(), overflowY: "auto" }}>
//           <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "0px" }}>
//             <thead>
//               <tr>
//                 <th style={tableHeaderStyle}>S.No</th>
//                 <th style={tableHeaderStyle}>Day</th>
//                 <th style={tableHeaderStyle}>Open Time</th>
//                 <th style={tableHeaderStyle}>Close Time</th>
//                 <th style={tableHeaderStyle}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {timings.map((item, index) => (
//                 <tr key={item.day || item.id}>
//                   <td style={tableCellStyle}>{index + 1}</td>
//                   <td style={tableCellStyle}>
//                     {item.isEditing ? (
//                       <input
//                         type="text"
//                         value={item.day}
//                         onChange={e => handleChange(index, 'day', e.target.value)}
//                         style={inputStyle}
//                       />
//                     ) : (
//                       item.day
//                     )}
//                   </td>
//                   <td style={tableCellStyle}>
//                     {item.isEditing ? (
//                       <input
//                         type="time"
//                         value={item.open}
//                         onChange={e => handleChange(index, 'open', e.target.value)}
//                         style={inputStyle}
//                       />
//                     ) : (
//                       item.open || '-'
//                     )}
//                   </td>
//                   <td style={tableCellStyle}>
//                     {item.isEditing ? (
//                       <input
//                         type="time"
//                         value={item.close}
//                         onChange={e => handleChange(index, 'close', e.target.value)}
//                         style={inputStyle}
//                       />
//                     ) : (
//                       item.close || '-'
//                     )}
//                   </td>
//                   <td style={tableCellStyle}>
//                     <button
//                       type="button"
//                       onClick={() => toggleEdit(index)}
//                       style={{
//                         ...buttonStyle,
//                         background: 'none',
//                         border: 'none',
//                         cursor: 'pointer',
//                         fontSize: '18px',
//                         color: '#4A148C',
//                         marginRight: '8px',
//                       }}
//                     >
//                       {item.isEditing ? <FaSave /> : <FaEdit />}
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => handleDeleteTiming(item.id)}
//                       style={{
//                         ...buttonStyle,
//                         background: 'none',
//                         border: 'none',
//                         cursor: 'pointer',
//                         fontSize: '18px',
//                         color: 'red',
//                       }}
//                       title="Delete Timing"
//                     >
//                       <FaTrash />
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </form>
//     </div>
//   );
// };

// // Styles remain the same...
// const tableHeaderStyle = {
//   border: '1px solid #ddd',
//   textAlign: 'center',
//   fontWeight: 'bold',
//   backgroundColor: '#b15cd6',
//   color: 'white',
// };

// const tableCellStyle = {
//   border: '1px solid #ddd',
//   textAlign: 'center',
// };

// const inputStyle = {
//   width: '100%',
//   border: 'none',
//   backgroundColor: 'transparent',
//   textAlign: 'center',
// };

// const buttonStyle = {
//   backgroundColor: '#dc3545',
//   color: 'white',
//   border: 'none',
//   borderRadius: '4px',
//   cursor: 'pointer',
//   marginRight: "5px"
// };

// export default Timings;




import React, { useState, useEffect } from "react";
import axios from 'axios';
import { FaEdit, FaTrash, FaSave } from 'react-icons/fa';
import { FaTimes } from 'react-icons/fa';

const Timings = () => {
  const [vendorId, setVendorId] = useState(null);
  const [timings, setTimings] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newTiming, setNewTiming] = useState({
    day: '',
    open: '',
    close: '',
  });

  // Define the correct order of days
  const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);

  const getTableHeight = () => {
    const width = window.innerWidth;

    if (width <= 600) return "400px";
    if (width >= 1000 && width <= 1300) return "400px";
    if (width > 1300) return "500px";

    return "auto";
  };

  // Sort timings by day order
  const sortTimingsByDay = (timingsArray) => {
    return [...timingsArray].sort((a, b) => {
      return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
    });
  };

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!storedVendorId || !token) {
      alert("Missing vendor ID or authentication token. Please log in again.");
      return;
    }

    const fetchTimings = () => {
      axios
        .get(
          `https://backend.maamaas.com/food/api/timings/get/timings/${storedVendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          const apiTimings = Array.isArray(response.data) ? response.data : [response.data];

          const mappedTimings = apiTimings.map((item) => ({
            id: item.id,
            day: item.day,
            open: item.startTime ? item.startTime.substring(0, 5) : '',
            close: item.lastTime ? item.lastTime.substring(0, 5) : '',
            checked: item.restaurantStatus === 'Open',
            restaurantStatus: item.restaurantStatus,
            isEditing: false,
          }));

          // Sort timings after mapping
          const sortedTimings = sortTimingsByDay(mappedTimings);
          setTimings(sortedTimings);
        })
        .catch((err) => {
          console.error('Failed to fetch timings', err);
          setTimings([]);
        });
    };

    fetchTimings();
    const intervalId = setInterval(fetchTimings, 10000);

    return () => clearInterval(intervalId);
  }, []);

  const handleAddTiming = () => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!vendorId) {
      alert("Vendor ID missing. Please refresh or login again.");
      return;
    }

    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    if (!newTiming.day || !newTiming.open || !newTiming.close) {
      alert("Please fill all fields.");
      return;
    }

    // Check if maximum 7 days reached
    if (timings.length >= 7) {
      alert("Maximum limit reached! You can only add 7 days (one for each day of the week).");
      return;
    }

    // Check if day already exists (case-insensitive)
    const dayExists = timings.some(timing => 
      timing.day.toLowerCase() === newTiming.day.toLowerCase()
    );
    
    if (dayExists) {
      alert(`Timing for ${newTiming.day} already exists!`);
      return;
    }

    const payload = {
      day: newTiming.day,
      startTime: newTiming.open + ":00",
      lastTime: newTiming.close + ":00",
    };

    console.log("Sending payload:", payload);

    axios
      .post(
        `https://backend.maamaas.com/food/api/timings/daytimings/${vendorId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        console.log("Success:", res.data);
        
        // Create new timing object
        const addedTiming = {
          id: res.data.id || Date.now(), // Use response ID or temporary ID
          day: res.data.day || newTiming.day,
          open: newTiming.open,
          close: newTiming.close,
          checked: false,
          restaurantStatus: 'Open',
          isEditing: false,
        };
        
        // Add to timings and sort
        const updatedTimings = sortTimingsByDay([...timings, addedTiming]);
        setTimings(updatedTimings);
        
        alert("Timing added successfully!");
        setShowAddModal(false);
        setNewTiming({ day: '', open: '', close: '' });
      })
      .catch((err) => {
        console.error("Failed to add timing:", err);
        if (err.response) {
          console.error("Status:", err.response.status);
          console.error("Data:", JSON.stringify(err.response.data, null, 2));
          alert("Error adding timing: " + JSON.stringify(err.response.data));
        } else {
          alert("Network error or server not reachable.");
        }
      });
  };

  const handleDeleteTiming = (id) => {
    const token = localStorage.getItem("authToken");

    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    if (!window.confirm('Are you sure you want to delete this timing?')) return;

    console.log('Deleting timing with id:', id);

    axios
      .delete(
        `https://backend.maamaas.com/food/api/timings/delete/day/timings/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        console.log('Deleted timing:', res.data);
        setTimings((prev) => prev.filter((timing) => timing.id !== id));
      })
      .catch((err) => {
        console.error('Failed to delete timing:', err.response?.data || err.message);
        alert('Failed to delete timing. Please try again.');
      });
  };

  const toggleEdit = (index) => {
    const timing = timings[index];
    const token = localStorage.getItem("authToken");

    if (!token) {
      alert("Authentication token missing. Please log in again.");
      return;
    }

    if (timing.isEditing) {
      const updatedData = {
        id: timing.id,
        day: timing.day,
        startTime: timing.open + ":00",
        lastTime: timing.close + ":00",
      };

      console.log("➡️ Sending PUT to edit timing:", updatedData);

      axios
        .put(
          `https://backend.maamaas.com/food/api/timings/edit/timings/${timing.id}`,
          updatedData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          const updatedTiming = res.data;
          
          // Update the timing in state
          setTimings(prev => {
            const updated = [...prev];
            updated[index] = {
              ...updated[index],
              day: updatedTiming.day,
              open: updatedTiming.startTime ? updatedTiming.startTime.substring(0, 5) : '',
              close: updatedTiming.lastTime ? updatedTiming.lastTime.substring(0, 5) : '',
              isEditing: false,
            };
            // Sort after update
            return sortTimingsByDay(updated);
          });

          alert("✅ Timing updated successfully!");
        })
        .catch((err) => {
          console.error("❌ Failed to update timing", err);
          console.error("🧾 Response:", err.response?.data);
          alert("Failed to save timing. Please try again.");
        });
    } else {
      setTimings(prev => {
        const updated = [...prev];
        updated[index].isEditing = true;
        return updated;
      });
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    const savedData = timings.map(({ day, open, close }) => ({ day, open, close }));
    console.log('Saved Timings:', savedData);
  };

  const handleChange = (index, field, value) => {
    setTimings(prev => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const handleNewTimingChange = (field, value) => {
    setNewTiming(prev => ({ ...prev, [field]: value }));
  };

  // Get available days (days that haven't been added yet)
  const getAvailableDays = () => {
    const existingDays = timings.map(timing => timing.day);
    return dayOrder.filter(day => 
      !existingDays.some(existingDay => 
        existingDay.toLowerCase() === day.toLowerCase()
      )
    );
  };

  // Disable add button if all 7 days are added
  const isAddButtonDisabled = timings.length >= 7;

  // Set default day when modal opens
  const handleOpenAddModal = () => {
    const availableDays = getAvailableDays();
    setNewTiming({
      day: availableDays[0] || '',
      open: '',
      close: '',
    });
    setShowAddModal(true);
  };

  return (
    <div style={{ padding: "0px", marginTop: "10px" }}>
      <form onSubmit={handleSubmit}>
        <button
          onClick={handleOpenAddModal}
          style={{
            marginBottom: '15px',
            padding: '8px 15px',
            fontSize: window.innerWidth <= 1300 ? '13px' : '16px',
            cursor: isAddButtonDisabled ? 'not-allowed' : 'pointer',
            backgroundColor: isAddButtonDisabled ? '#cccccc' : 'rgb(177 92 214)',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontWeight: 'bold',
            opacity: isAddButtonDisabled ? 0.6 : 1,
          }}
          disabled={isAddButtonDisabled}
          title={isAddButtonDisabled ? "All 7 days already added" : "Add new timing"}
        >
          Add + 
        </button>

        {showAddModal && (
          <div
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
            }}
          >
            <div
              style={{
                backgroundColor: 'white',
                padding: '24px',
                borderRadius: '10px',
                width: '360px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                position: 'relative',
                fontFamily: 'Arial, sans-serif',
              }}
            >
              <button
                onClick={() => setShowAddModal(false)}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  color: '#000',
                  border: 'none',
                  borderRadius: '50%',
                  width: '30px',
                  height: '30px',
                  fontSize: '16px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                aria-label="Close modal"
              >
                <FaTimes />
              </button>

              <h3 style={{ marginBottom: '20px', color: '#4A148C', textAlign: 'center' }}>Add Timing</h3>
              
              {/* <div style={{ marginBottom: '10px', textAlign: 'center', color: '#666', fontSize: '14px' }}>
                {timings.length} of 7 days added
              </div> */}

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Day:</label>
                <select
                  value={newTiming.day}
                  onChange={e => handleNewTimingChange('day', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    fontSize: '14px',
                  }}
                >
                  {getAvailableDays().map(day => (
                    <option key={day} value={day}>{day}</option>
                  ))}
                </select>
                {getAvailableDays().length === 0 && (
                  <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                    All days have been added!
                  </div>
                )}
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Open Time:</label>
                <input
                  type="time"
                  value={newTiming.open}
                  onChange={e => handleNewTimingChange('open', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    fontSize: '14px',
                  }}
                  required
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Close Time:</label>
                <input
                  type="time"
                  value={newTiming.close}
                  onChange={e => handleNewTimingChange('close', e.target.value)}
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    fontSize: '14px',
                  }}
                  required
                />
              </div>

              <div style={{ textAlign: 'center' }}>
                <button
                  onClick={handleAddTiming}
                  disabled={getAvailableDays().length === 0 || !newTiming.open || !newTiming.close}
                  style={{
                    padding: '10px 20px',
                    cursor: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? 'not-allowed' : 'pointer',
                    backgroundColor: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? '#cccccc' : 'rgb(177, 92, 214)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    fontSize: '15px',
                    opacity: (getAvailableDays().length === 0 || !newTiming.open || !newTiming.close) ? 0.6 : 1,
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

        <div style={{ height: getTableHeight(), overflowY: "auto" }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "0px" }}>
            <thead>
              <tr>
                <th style={tableHeaderStyle}>S.No</th>
                <th style={tableHeaderStyle}>Day</th>
                <th style={tableHeaderStyle}>Open Time</th>
                <th style={tableHeaderStyle}>Close Time</th>
                <th style={tableHeaderStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {timings.map((item, index) => (
                <tr key={item.id || item.day}>
                  <td style={tableCellStyle}>{index + 1}</td>
                  <td style={tableCellStyle}>
                    {item.isEditing ? (
                      <select
                        value={item.day}
                        onChange={e => handleChange(index, 'day', e.target.value)}
                        style={inputStyle}
                      >
                        {dayOrder.map(day => (
                          <option key={day} value={day}>{day}</option>
                        ))}
                      </select>
                    ) : (
                      item.day
                    )}
                  </td>
                  <td style={tableCellStyle}>
                    {item.isEditing ? (
                      <input
                        type="time"
                        value={item.open}
                        onChange={e => handleChange(index, 'open', e.target.value)}
                        style={inputStyle}
                      />
                    ) : (
                      item.open || '-'
                    )}
                  </td>
                  <td style={tableCellStyle}>
                    {item.isEditing ? (
                      <input
                        type="time"
                        value={item.close}
                        onChange={e => handleChange(index, 'close', e.target.value)}
                        style={inputStyle}
                      />
                    ) : (
                      item.close || '-'
                    )}
                  </td>
                  <td style={tableCellStyle}>
                    <button
                      type="button"
                      onClick={() => toggleEdit(index)}
                      style={{
                        ...buttonStyle,
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '18px',
                        color: '#4A148C',
                        marginRight: '8px',
                      }}
                    >
                      {item.isEditing ? <FaSave /> : <FaEdit />}
                    </button>
                    <button
                      type="button"
                      onClick={() => handleDeleteTiming(item.id)}
                      style={{
                        ...buttonStyle,
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '18px',
                        color: 'red',
                      }}
                      title="Delete Timing"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </form>
    </div>
  );
};

const tableHeaderStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
  fontWeight: 'bold',
  backgroundColor: '#b15cd6',
  color: 'white',
};

const tableCellStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
};

const inputStyle = {
  width: '100%',
  border: 'none',
  backgroundColor: 'transparent',
  textAlign: 'center',
};

const buttonStyle = {
  backgroundColor: '#dc3545',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  marginRight: "5px"
};

export default Timings;